import React, { useMemo } from "react";
import { IMenuTileCarouselComponentProps } from "../components";

/**
 * Hook to return the variant map based on variantId
 */
export const useVariantIDMap = (variantId: string) => {
  return useMemo<{
    size: IMenuTileCarouselComponentProps["size"];
    isBorder: IMenuTileCarouselComponentProps["isBorder"];
  }>(() => {
    const variantIDmap: Record<
      string,
      {
        size: IMenuTileCarouselComponentProps["size"];
        isBorder: IMenuTileCarouselComponentProps["isBorder"];
      }
    > = {
      DEFAULT: { size: "default", isBorder: false },
      SINGLE_ROW_WIDE_IMAGE: { size: "wide", isBorder: false },
      SINGLE_ROW_STROKE_IMAGE: { size: "default", isBorder: true },
      SINGLE_ROW_STROKE_WIDE_IMAGE: { size: "wide", isBorder: true },
      TWO_ROW_LARGE_IMAGE: { size: "default", isBorder: false },
      TWO_ROWS_WIDE_IMAGE: { size: "largeWide", isBorder: false },
      TWO_ROWS_STROKE_IMAGE: { size: "large", isBorder: true },
      TWO_ROWS_STROKE_WIDE_IMAGE: { size: "largeWide", isBorder: true },
    };
    return variantIDmap[variantId];
  }, [variantId]);
};

export default useVariantIDMap;
